import { Layout, Meta } from '../../components';
import { Footer, Header } from '../../sections';

export type LayoutFixedProps = {
  children?: React.ReactNode;
};

export function LayoutFixed({ children }: LayoutFixedProps) {
  return (
    <>
      <Meta />
      <Layout>
        <Header fixed />
        {children}
        <Footer />
      </Layout>
    </>
  );
}
